import { Component, OnInit } from "@angular/core";
import { AuthenticateService } from "../../shared/services/authenticate.service";
import { RepoService } from "../../shared/services/repo.service";
import { UUID } from "angular2-uuid";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { FileUploadService } from "src/app/shared/services/fileupload.service";

@Component({
  selector: "app-machine",
  templateUrl: "./machine.component.html",
  styleUrls: ["./machine.component.sass"],
})
export class MachineComponent implements OnInit {
  machineDataArray = [];
  showforms: boolean = true;
  globalImgUrl: string;
  imageUploadService: string;
  urls = "";
  imageName = "";
  uploadFile: any;
  tagName: string;
  tagsArray = [];
  deviceArray = [];
  deviceName: any[];
  machineGrp: FormGroup;
  groupName: string;
  public loading: boolean;
  btnLoading: boolean = false;
  cobj: any = {};
  machineryName: any;
  type: string = "save";
  updateUUID: string = "";
  previousPage: number;
  skip: number;
  collectionSize: number;
  searchStr: string = "";
  showsearchdata: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private repoService: RepoService,
    private authService: AuthenticateService,
    private modalService: NgbModal,
    private cognitoService: CognitoService,
    private fileUploadService: FileUploadService
  ) { }
  config = {
    displayKey: "deviceName", // if objects array passed which key to be displayed defaults to description
    search: true,
    limitTo: 100,
    height: "225px",
  };
  ngOnInit() {
    this.globalImgUrl = this.authService.s3url();
    this.cognitoService.getCurrentUserToken().then((res: any) => {
      this.groupName = res.attributes.family_name;
      this.getFarmMachinaryRepo();
    });
    this.machineGrp = this.formBuilder.group({
      MachineName: ["", Validators.required],
      mGroup: ["", Validators.required],
    });
  }

  imageInput(event) {
    if (event.target.files && event.target.files[0]) {
      var fileLength = event.target.files.length;
      for (let i = 0; i < fileLength; i++) {
        if (event.target.files[i].type.split("/")[0] == "image") {
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.urls = event.target.result;
          };
          reader.readAsDataURL(event.target.files[i]);
          let iuuid = UUID.UUID();
          this.imageUploadService =
            "machine_" +
            iuuid +
            "." +
            event.target.files.item(0).type.split("/")[1];
          this.imageName = this.imageUploadService;
          const formData: FormData = new FormData();
          formData.set("file", event.target.files[i], this.imageUploadService);
          formData.append("name", this.imageUploadService);
          this.uploadFile = formData;
        }
      }
    }
  }

  deleteImage() {
    this.imageName = "";
    this.uploadFile = "";
    this.urls = "";
  }

  openModal(content) {
    console.log("grpname", this.groupName);
    let config: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "lg",
    };
    // this.tagsArray = [];
    // this.tagsArray = this.deviceArray;
    this.modalService.open(content, config);
  }

  handleInput(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }

  addTags(tag) {
    console.log("add tags ", tag);
    if (tag != undefined) {
      this.deviceArray = this.deviceArray.concat([tag]);
    }
    this.tagName = "";
  }

  addform() {
    this.btnLoading = false;
    this.machineGrp.reset();
    this.showforms = false;
    this.cobj = {};
    console.log("cobj", this.cobj);
    this.type = "save";
  }

  saveDevice() {
    // this.deviceArray = this.deviceArray.concat(this.tagsArray);
    console.log("da", this.deviceArray);
  }

  uploadFileToActivity() {
    // this.repoService.uploadFileTos3(this.uploadFile).then(data => {
    // }, error => {
    //   console.log(error);
    // });
    this.fileUploadService.uploadFile(this.uploadFile, this.imageUploadService);
  }

  back() {
    this.showforms = true;
    this.type = "back";
    this.machineGrp.reset();
    // this.imageNameList = [];
    this.urls = "";
    this.getFarmMachinaryRepo();
  }
  saveData() {
    this.showforms = true;
    this.loading = true;
    console.log("tagsarray", this.tagsArray);
    this.deviceArray = this.tagsArray;
    console.log("devicearray", this.deviceArray);
    this.uploadFileToActivity();
    // let uuid = UUID.UUID();
    this.cobj.machineryId = UUID.UUID();
    this.cobj.machineryImage = this.imageName;
    this.cobj.group = this.groupName;
    this.cobj.tags = this.tagsArray;
    this.cobj.machineryName = this.machineryName;

    // this.machineDataArray = this.cobj;

    this.repoService.createMachinery(this.cobj).then((data: any) => {
      console.log("saveData result : ", JSON.stringify(data));
      if (data) {
        this.loading = false;
        this.machineGrp.reset();
        this.imageName = "";
        this.urls = "";
        this.showforms = true;
        this.uploadFile = "";
        this.getFarmMachinaryRepo();
      } else {
        this.loading = false;
        this.btnLoading = false;
        Swal.fire(
          "Error",
          "Data not Submitted (please contact admin)",
          "error"
        );
      }
    });
  }

  editData(i) {
    this.cobj = {};
    this.updateUUID = this.machineDataArray[i].machineryId;
    this.machineryName = this.machineDataArray[i].machineryName;
    this.deviceName = this.machineDataArray[i].tags;
    this.imageName = this.machineDataArray[i].machineryImage;
    this.tagsArray = this.machineDataArray[i].tags;
    this.urls = this.globalImgUrl + this.machineDataArray[i].machineryImage;
    this.deviceArray = this.machineDataArray[i].tags;
    this.type = "update";
    this.showforms = false;
  }

  selectionChanged() {
    console.log("da1", this.deviceArray);
  }

  updateData() {
    this.showforms = true;
    this.cobj.machineryImage = this.imageName;
    this.cobj.group = this.groupName;
    this.cobj.tags = this.tagsArray;
    this.cobj.machineryName = this.machineryName;
    this.uploadFileToActivity();
    this.repoService
      .updateFarmMachinary(this.cobj, this.updateUUID)
      .then((data: any) => {
        console.log("update data : ", data);
        this.getFarmMachinaryRepo();
      });
  }

  loadPage(pageNumber: number) {
    this.loading = true;
    console.log("page number ", pageNumber, this.previousPage);
    if (pageNumber !== this.previousPage) {
      this.skip = pageNumber * 20 - 20;
      this.previousPage = pageNumber;
      this.loadData(this.skip);
    }
  }

  loadData(skip) {
    var count = { group: this.groupName };
    this.repoService.getFarmMachinaryRepocount(count).then((data: any) => {
      console.log("Demand size : ", data);
      if (data.length > 0) {
        this.collectionSize = data[0].size;
        var options = {
          group: this.groupName,
          // options: {
          limit: 20,
          // sortFields: { createTs: -1 },
          skip: skip,
          // },
        };
        this.repoService.getFarmMachinaryRepo(options).then((data: any) => {
          console.log("getDemandCount : ", data);
          if (data.length > 0) {
            this.machineDataArray = data;
            this.loading = false;
          } else {
            this.loading = false;
          }
        });
      } else {
        this.loading = false;
      }
    });
  }

  getFarmMachinaryRepo() {
    this.loading = true;
    this.showsearchdata = true;
    var count = { group: this.groupName };
    this.repoService.getFarmMachinaryRepocount(count).then((data: any) => {
      console.log("COUNT : ", data);
      if (data.length > 0) {
        this.collectionSize = data[0].size;
        var options = {
          group: this.groupName,
          // options: {
          limit: 20,
          // sortFields: { createTs: -1 },
          skip: 0,
          // },
        };
        this.machineDataArray = [];
        this.repoService.getFarmMachinaryRepo(options).then((data: any) => {
          console.log("machinaryData == ", data);
          if (data.length > 0) {
            let tagArr = [];
            data.forEach((element) => {
              element.tags.forEach((element1) => {
                tagArr.push(element1);
                this.deviceArray = Array.from(new Set(tagArr));
                this.tagsArray = this.deviceArray;
              });
            });
            this.machineDataArray = data;
            console.log("machinedataarray", this.machineDataArray);
            this.loading = false;
          } else {
            this.loading = false;
          }
        });
      } else {
        this.loading = false;
      }
    });
  }
  onImgError(event) {
    event.target.src = this.globalImgUrl + "agri_logo.png";
  }

  // searchByName() {
  //   if (this.searchStr != '') {
  //     var obj;
  //     obj = {
  //       "machineryName": this.searchStr,
  //       group: this.groupName
  //     }
  //     console.log("search obj : ", obj)
  //     this.repoService.getDataBysearchstr('farmmachinery', obj).then((data: any) => {
  //       console.log("searched", data);
  //       this.searchStr = '';
  //       this.machineDataArray = [];
  //       if (data.length > 0) {
  //         this.machineDataArray = data;
  //         this.showsearchdata = false;
  //         console.log("machineDataArray", this.machineDataArray);
  //       }
  //       else {
  //         this.showsearchdata = false;
  //       }
  //     })
  //     // this.getRegisteredData(obj);
  //   }
  // }
}
